import React from 'react'
import ReactDOM from 'react-dom'

const Empty = () => {
    return <div className="happy-cart-small__empty">
        - Пусто -
    </div>
}

export default Empty